import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackage } from '@/api/model/interfaces';

export default class DrawingPackageOdata extends OdataManager<DrawingPackage> {}
